function HomePage(){
  return(
<div className="homePage">
  <div id="nameImg">
  <h1>Johnathan Weil</h1>
  <img src="https://i.imgur.com/sU1Qk1U.jpg" alt="none" className="self-img" /> 
  </div>

  <div className="about-me">
    <h2>About Me</h2>
    <p>
    I was in college before with the intention of pursuing a career in
    Chemistry when I realized that it was not for me, So I decided to pursue
    a career in Software Enginnering. Some things I am passionate about
    outside of SWE are competitive video games such as Rainbow Six: Siege
    and Valorant. As well as working out, math, and science(specifically
    Chemistry and physics).
    </p>
  </div>
</div>
  
  )
}

export default HomePage